import { Button } from '@timelyapp/react';
import type { DropdownOption } from 'components/DropdownListWithOptions';
import PopoverDropdownList from 'components/popovers/PopoverDropdownList';
import {
  WIDGET_CLIENTS_HBAR,
  WIDGET_CLIENTS_LIST,
  WIDGET_LABELS_HBAR,
  WIDGET_LINKED_WORK_LIST,
  WIDGET_TEAMS_LIST,
  WIDGET_USERS_HBAR,
} from 'constants/widgets';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReportData } from 'redux/modules/superreports.actions';
import type { changeWidgetType, WidgetDraft } from 'redux/modules/superreports.types';
import { getWidgetMetadata } from 'redux/selectors/superreports';
import type { ThunkDispatch } from 'types/redux';
import styles from './TableWidget.module.scss';

interface Props {
  changeWidgetType?: typeof changeWidgetType;
  readOnly?: boolean;
  widget: WidgetDraft;
}

const TableWidgetHeader: React.FC<Props> = ({ widget, readOnly, changeWidgetType }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const widgetMetadata = useSelector(getWidgetMetadata);
  const groupByOptions = useMemo(
    (): Array<DropdownOption> => [
      {
        name: widgetMetadata[WIDGET_CLIENTS_HBAR]?.title ?? '???',
        action: WIDGET_CLIENTS_HBAR,
      },
      {
        name: widgetMetadata[WIDGET_USERS_HBAR]?.title ?? '???',
        action: WIDGET_USERS_HBAR,
      },
      {
        name: widgetMetadata[WIDGET_CLIENTS_LIST]?.title ?? '???',
        action: WIDGET_CLIENTS_LIST,
      },
      {
        name: widgetMetadata[WIDGET_LABELS_HBAR]?.title ?? '???',
        action: WIDGET_LABELS_HBAR,
      },
      {
        name: widgetMetadata[WIDGET_TEAMS_LIST]?.title ?? '???',
        action: WIDGET_TEAMS_LIST,
      },
      {
        name: widgetMetadata[WIDGET_LINKED_WORK_LIST]?.title ?? '???',
        action: WIDGET_LINKED_WORK_LIST,
      },
    ],
    [widgetMetadata]
  );

  const handleChangeGroupBy = (option: DropdownOption) => {
    if (option.action === widget.widget_type) return;
    changeWidgetType?.({
      widgetReference: widget.id || widget._ref,
      widgetType: option.action!,
    });
    dispatch(fetchReportData(false));
  };

  return (
    <>
      {!readOnly ? (
        <PopoverDropdownList
          fixed
          options={groupByOptions}
          onClick={handleChangeGroupBy}
          target={
            <Button priority="low" className={styles.title}>
              {widget.title}
            </Button>
          }
        />
      ) : (
        widget.title
      )}
    </>
  );
};

export default TableWidgetHeader;
